module.exports = __webpack_public_path__ + "assets/injection.929a5bf1.svg";